import { render, staticRenderFns } from "./ThresholdSetting.vue?vue&type=template&id=2535e067&"
import script from "./ThresholdSetting.vue?vue&type=script&lang=js&"
export * from "./ThresholdSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QToggle,QCardSection,QInnerLoading,QSpinnerTail,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QToggle,QCardSection,QInnerLoading,QSpinnerTail,QTooltip})
